import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { Model, ModelQueryParams, ModelsCreateParams, ModelsExtract, ModelsExtractParams } from '../models/model.model';

export abstract class ModelGateway {
  abstract listModels(params: ModelQueryParams): Observable<ListResponse<Model>>;
  abstract listExtractModels(params: ModelsExtractParams): Observable<ListResponse<ModelsExtract>>;
  abstract createModels(params: ModelsCreateParams): Observable<ListResponse<Model>>;
  abstract deleteModel(modelId: string): Observable<void>;
}
